import { point, area } from '@turf/turf'
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw'
import BaseTool from '@/components/geoview/tools/BaseTool'

class Measure extends BaseTool {
  constructor (mapHelper, data) {
    super(mapHelper, data)
    this.mode = 'select'
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: false,
        trash: false
      },
      defaultMode: 'simple_select'
    })

    this.getMap().addControl(this.draw)

    this.getMap().on('draw.create', this.drawCreate)
    this.getMap().on('draw.update', this.drawUpdate)
  }

  async onClick (e) {
    switch (this.mode) {
      case 'draw':
        return this.onClickDraw(e)
      case 'select':
      default:
        return this.onClickSelect(e)
    }
  }

  async onClickDraw (e) {
    if (this.draw.getMode() !== 'draw_polygon') {
      if (this.draw.getAll().features.length > 0 && this.draw.getAll().features[0].geometry.type !== 'Point') {
        this.draw.changeMode('direct_select', { featureId: this.draw.getAll().features[0].id })
      } else {
        this.draw.deleteAll()
        this.draw.changeMode('draw_polygon')
      }
      return
    }
    let pointt = point([e.lngLat.lat, e.lngLat.lng])
    this.draw.add(pointt)
  }

  async onClickSelect (e) {
    let layerNames = []
    for (let layerId in this.mapHelper.layers) {
      if (!this.mapHelper.layers.hasOwnProperty(layerId)) {
        return
      }
      layerNames.push(this.mapHelper.layers[layerId].getLayerId())
    }
    let f = this.getMap().queryRenderedFeatures(e.point, { layers: layerNames })

    if (f.length === 0) {
      if (this.draw.getAll().features.length > 0) {
        // keep the current selected feature selected
        this.draw.changeMode('simple_select', { featureId: this.draw.getAll().features[0].id })
      }
      return
    }

    let poly = JSON.parse(f[0].properties.polygon)
    this.mapHelper.onToolInfo(Math.round(area(poly) * 100) / 100 + ' m²')
    this.draw.deleteAll()
    this.draw.add(poly)
  }

  update (data) {
    switch (data) {
      case 'delete':
        if (this.draw.getAll().features.length === 0) {
          // es gibt nichts zu löschen
          return
        }

        if (this.mode === 'draw') {
          this.draw.trash()
        } else {
          this.draw.deleteAll()
        }

        if (this.draw.getMode() === 'simple_select' && this.mode === 'draw') {
          // alles löschen, damit die features wieder leer sind (keine 'points') vorhanden
          this.draw.deleteAll()
          this.draw.changeMode('draw_polygon')
        }
        return true
      // return this.update(this.mode)
      case 'draw':
        if (this.mode === 'draw') {
          return
        }
        // alles resetten, wenn mode geändert wird
        this.draw.deleteAll()
        this.mapHelper.onToolInfo('')

        this.mode = 'draw'
        this.draw.changeMode('draw_polygon')
        break
      case 'select':
      default:
        if (this.mode !== 'select') {
          // alles resetten, wenn mode geändert wird
          this.draw.deleteAll()
          this.mapHelper.onToolInfo('')
        }
        this.mode = 'select'
    }
  }

  destroy () {
    this.getMap().removeControl(this.draw)
    this.getMap().off('draw.create', this.drawCreate)
    this.getMap().off('draw.update', this.drawUpdate)
  }

  drawCreate = (e) => {
    this.mapHelper.onToolInfo(Math.round(area(e.features[0]) * 100) / 100 + ' m²')
  }

  drawUpdate = (e) => {
    this.mapHelper.onToolInfo(Math.round(area(e.features[0]) * 100) / 100 + ' m²')
  }
}

export default Measure
